<div class="modal-header" *ngIf="!data?.hideHeader">
  <h2>{{data?.title}}</h2>
  <app-button mat-dialog-close (onCLick)="onClose()" icon="close"></app-button>
</div>

<div class="modal-content-wrap" [ngClass]="{ 'modal-content-wrap_fixed-long': data.fullscreen }">
  <ng-container *ngTemplateOutlet="data?.component"></ng-container>
</div>